import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectPaymentActivationApi = {
  getPaymentTriggerMilestones: async (source, requestId) => {
    const q =
      requestId != null && requestId !== ""
        ? `?requestId=${encodeURIComponent(requestId)}`
        : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPaymentTriggerMilestones${q}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getPaymentActivations: async (source, { requestId, projectExecutionPlanId } = {}) => {
    const params = new URLSearchParams();
    if (requestId) params.set("requestId", requestId);
    if (projectExecutionPlanId) params.set("projectExecutionPlanId", projectExecutionPlanId);
    const q = params.toString() ? `?${params.toString()}` : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPaymentActivations${q}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  createPaymentActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CreatePaymentActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  approvePaymentActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ApprovePaymentActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  suspendPaymentActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/SuspendPaymentActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  cancelPaymentActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CancelPaymentActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  completePaymentActivation: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CompletePaymentActivation`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectPaymentActivationApi;
